import ApiInfo from './ApiInfo.js';

class QukanApiInfo extends ApiInfo {
    // 声明接口类
    constructor ({ path, type = 'get', timeout = 5000, headers, project = 'qukan', author = '未定义' }) {
        super({
            path,
            type,
            timeout,
            headers,
            project,
            author
        });
    }
}

export default {
    api: {
        login: new QukanApiInfo({
            path: '/api/login',
            type: 'post',
            author: '张颢'
        }),
        loginNew: new QukanApiInfo({
            path: '/api/login_new',
            type: 'post',
            author: '张颢'
        }),
        getAppList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/app',
            type: 'get',
            author: '张颢'
        }),
        getTopicList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/topic',
            type: 'get',
            author: '张颢'
        }),
        getCmdRangeList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/cmd_range',
            type: 'get',
            author: '张颢'
        }),
        getTopicCmdList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/topic_cmd',
            type: 'get',
            author: '张颢'
        }),
        getOutCmdList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/topic_out_cmd',
            type: 'get',
            author: '张颢'
        }),
        getCmdList: new QukanApiInfo({
            // 声明接口对象
            path: '/api/cmd',
            type: 'get',
            author: '张颢'
        }),
        addTopicCmd: new QukanApiInfo({
            path: '/api/add_topic_cmd',
            type: 'post',
            author: '张颢'
        }),
        addCmd: new QukanApiInfo({
            path: '/api/add_cmd',
            type: 'post',
            author: '张颢'
        }),
        delCmd: new QukanApiInfo({
            path: '/api/del_cmd',
            type: 'post',
            author: '张颢'
        }),
        modCmd: new QukanApiInfo({
            path: '/api/mod_cmd',
            type: 'post',
            author: '张颢'
        }),
        getActionMetricList: new QukanApiInfo({
            path: '/api/cmd_detail_new',
            type: 'get',
            author: '张颢'
        }),
        getCmdDetailList: new QukanApiInfo({
            path: '/api/cmd_detail',
            type: 'get',
            author: '张颢'
        }),
        getCmdDetailMetricKeyList: new QukanApiInfo({
            path: '/api/cmd_detail_metric_key',
            type: 'get',
            author: '张颢'
        }),
        addCmdMetric: new QukanApiInfo({
            path: '/api/add_cmd_metric',
            type: 'post',
            author: '张颢'
        }),
        modCmdMetric: new QukanApiInfo({
            path: '/api/mod_cmd_metric',
            type: 'post',
            author: '张颢'
        }),
        delCmdMetric: new QukanApiInfo({
            path: '/api/del_cmd_metric',
            type: 'post',
            author: '张颢'
        }),
        addCmdDetail: new QukanApiInfo({
            path: '/api/add_cmd_key',
            type: 'post',
            author: '张颢'
        }),
        delCmdDetail: new QukanApiInfo({
            path: '/api/del_cmd_key',
            type: 'post',
            author: '张颢'
        }),
        modCmdDetail: new QukanApiInfo({
            path: '/api/mod_cmd_key',
            type: 'post',
            author: '张颢'
        }),
        addCmdMetricKey: new QukanApiInfo({
            path: '/api/add_cmd_metric_key',
            type: 'post',
            author: '张颢'
        }),
        delCmdMetricKey: new QukanApiInfo({
            path: '/api/del_cmd_metric_key',
            type: 'post',
            author: '张颢'
        }),
        modCmdMetricKey: new QukanApiInfo({
            path: '/api/mod_cmd_metric_key',
            type: 'post',
            author: '张颢'
        }),
        getApproveList: new QukanApiInfo({
            path: '/api/apply',
            type: 'get',
            author: '张颢'
        }),
        approveApply: new QukanApiInfo({
            path: '/api/approve',
            type: 'post',
            author: '张颢'
        }),
        getUserList: new QukanApiInfo({
            path: '/api/role',
            type: 'get',
            author: '张颢'
        }),
        modRole: new QukanApiInfo({
            path: '/api/mod_role',
            type: 'post',
            author: '张颢'
        })
    }
};



// WEBPACK FOOTER //
// ./src/core/Apis/Qukan.js